import {
	HOME_OVERVIEW_EXPERIENCE,
	HOME_RECENT_EXPERIENCE,
	HOME_STARRED_EXPERIENCE,
	HOME_WATCHING_EXPERIENCE,
	HOME_DRAFTS_EXPERIENCE,
	HOME_EXPERIENCE,
} from './ExperienceName.ts';
import { getExperienceTracker } from './getExperienceTracker.ts';
import { collectAny } from './ExperienceEventCollector.ts';

const homeSubExperiences = [
	HOME_OVERVIEW_EXPERIENCE,
	HOME_RECENT_EXPERIENCE,
	HOME_STARRED_EXPERIENCE,
	HOME_WATCHING_EXPERIENCE,
	HOME_DRAFTS_EXPERIENCE,
];

export function startHome(): void {
	getExperienceTracker().start({
		name: HOME_EXPERIENCE,
		collect: collectAny(homeSubExperiences),
	});
}
